import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  background: (p) => p.palette.primary[50],
  p: (p) => p.spacing(1, 1.5),
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.primary[100],
};

export const tableWrapper: SxStyle = {
  padding: (p) => p.spacing(1),
  width: '100%',
};
